// import React from 'react'

// const CreateProducts = () => {
//   return (
//     <div>

//     </div>
//   )
// }

import React, { useState, useEffect, useContext } from "react";
import {
  AppBar,
  Typography,
  Button,
  TextField,
  Box,
  Breadcrumbs,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  IconButton,
  Link,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Tooltip,
  Autocomplete,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { PageDataContext } from "../../utils/common/PageDataContext";
import {
  SETTING_API_01,
  SETTING_API_02,
  SETTING_API_05,
  SETTING_API_06,
  SETTING_API_07,
  SETTING_API_08,
} from "../../api/ApiModel";
import { externalgetApi } from "../../services/externalApis";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import SnackbarMessage from "../../components/common/SystemAlert";
import { useSelector } from "react-redux";
import { externalpostApi } from "../../services/externalApis";
import { useLocation } from "react-router-dom";
import SystemAlert from "../../components/common/SystemAlert";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import ImageCropper from "../../components/common/ImageCropper";
import {
  CON_MENUICON_WIDTH,
  CON_MENUICON_HEIGHT,
  CON_MAX_FILESIZE_ITEMIMG,
} from "../../utils/sys/Constants";

function CreateProducts() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const location = useLocation();
  const { selectedItem } = location.state || {};
  const [alertOpen, setAlertOpen] = useState(false); // State to control alert visibility
  const [alertType, setAlertType] = useState("success"); // Type of alert (e.g., success, error, warning)
  const [alertMessage, setAlertMessage] = useState("");
  const SYS_USER = useSelector((state) => state.user) || {};
  const { LOCCODE, RESTCODE, USERNAME, COMPCODE, STAFFMAPLOCODE } = SYS_USER.USER_PARAM || {};
  const isEdit = location.state?.actionText === "Edit";

  const [datacat, setDatacat] = useState(null);
  const [datasubcat, setDatasubcat] = useState(null);
  const [databrand, setDatabrand] = useState(null);
  const [datapack, setDatapack] = useState(null);
  const [datamou, setDatamou] = useState(null);

  const [filePath, setFilePath] = useState("");
  const [croppedImg, setCroppedImg] = useState("");
  const [error, setError] = useState("");
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    productname: "",
    catcode: "",
    subcatcode: "",

    brandcode: "",
    packagecode: "",
    productcode: "",
    minorderlevel: 0,
    productsize: 0,
    packageunits: 0,
    immeasuringunitcode: "",
    imagepath: "",

    catname: "",
    subcatname: "",
    brandname: "",
    packagename: "",
    immeasuringunit: "",
    descrip: "",
  });

  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
        catcode: selectedItem.catcode,
        subcatcode: selectedItem.subcatcode,
        catname: selectedItem.catname,
        subcatname: selectedItem.subcatname,
        brandname: selectedItem.brandname,

        brandcode: selectedItem.brandcode,
        packagename: selectedItem.packagename,
        packagecode: selectedItem.packagecode,
        productname: selectedItem.productname,
        descrip: selectedItem.descrip|| "",
        productcode: selectedItem.productcode,
        minorderlevel: selectedItem.minorderlevel || 0,
        productsize: selectedItem.productsize || 0,
        immeasuringunit: selectedItem.immeasuringunit   || "",
        immeasuringunitcode: selectedItem.immeasuringunitcode   || "",
        packageunits: selectedItem.packageunits   || 0,
        imagepath: selectedItem.imagepath   || "",
      });
      console.log("Selected Item Details:", selectedItem.imagepath);
    }
  }, [selectedItem]);

  console.log("Selected Item Details:", selectedItemDetails);

  useEffect(() => {
    setPageData({
      title: "Product",
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, []);

  const goBackToView = () => {
    navigate("/vCreateProducts");
  };

  const handleCroppedImage = (img) => {
    setCroppedImg(img);

    console.log("Received cropped image from child:", img);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = typeof value === "string" ? value.trim() : value;

    // Prevent initial space only
    if (typeof value === "string" && value.length === 1 && value[0] === " ") {
      return;
    }

    // Validate max length
    if (typeof value === "string" && value.length > 30) {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot exceed 30 characters.",
      }));
      return;
    }

    // Validate empty string
    if (typeof value === "string" && trimmedValue === "") {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot be empty or just spaces.",
      }));
    } else {
      setError((prevError) => ({
        ...prevError,
        [name]: "",
      }));
    }

    // Always update the value
    setSelectedItemDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };


  const handlenumInputChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = typeof value === "string" ? value.trim() : value;
  
    // Prevent initial space only
    if (typeof value === "string" && value.length === 1 && value[0] === " ") {
      return;
    }
  
    // Validate numeric input (allow integers and floats)
    const isNumeric = /^[0-9]*\.?[0-9]*$/.test(value); // Regular expression to allow numbers with optional decimal points
    if (!isNumeric) {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input must contain only numbers or decimals.",
      }));
      return; // Prevent state update if input is not numeric
    }
  
    // Clear the value if it is "0" when focused
    if (value === "0") {
      setSelectedItemDetails((prevDetails) => ({
        ...prevDetails,
        [name]: "",
      }));
      return;
    }
  
    // Clear error if input is valid
    setError((prevError) => ({
      ...prevError,
      [name]: "",
    }));
  
    // Always update the value
    setSelectedItemDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleInputChangedes = (e) => {
    const { name, value } = e.target;
    const trimmedValue = typeof value === "string" ? value.trim() : value;
  
    // Prevent initial space only
    if (typeof value === "string" && value.length === 1 && value[0] === " ") {
      return;
    }
  

  
    // Validate empty string
    if (typeof value === "string" && trimmedValue === "") {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot be empty or just spaces.",
      }));
    } else {
      setError((prevError) => ({
        ...prevError,
        [name]: "",
      }));
    }
  
    // Always update the value
    setSelectedItemDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  }
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTING_API_07, "get", {
          COMPCODE,
          LOCCODE: STAFFMAPLOCODE,

          STS: CON_STATUS_ACTIVE,
        });

        setData(result);
        console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleConfirmClick = async () => {
    setIsButtonDisabled(true);
    const { productname,catname,subcatname,brandname,packagename,immeasuringunit } = selectedItemDetails;

    const requiredFields = [
      { name: "productname", value:productname, label: "Product Name" },
      { name: "catname", value:catname, label: "Category Name" },
      { name: "subcatname", value:subcatname, label: "Subcategory Name" },
      { name: "brandname", value:brandname, label: "Brand Name" },
      { name: "packagename", value:packagename, label: "Package Name" },
   
      { name: "immeasuringunit", value:immeasuringunit, label: "Measuring Unit" },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`;
      });
      setError(newError);

      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      //  const errorMessage = `Required fields: ${missingFieldLabels}.`;
      const errorMessage = `Please Fill All the Required Fields.`;
      setAlertType("error");
      setAlertMessage("Please Fill All the Required Fields.");
      setAlertOpen(true); // Open the alert
      setIsButtonDisabled(false);
      return;
    }

    if (data) {
      const isDuplicate = data.some((item) => {
        if (
          item.productcode !== selectedItemDetails.productcode &&
   
          item.productname.toLowerCase() === productname.toLowerCase()
        ) {
          return true;
        } else {
          return false;
        }
      });

      if (isDuplicate) {
        setAlertMessage("Product Already Exists.");
        setAlertType("warning");

        setAlertOpen(true); // Open the alert
        return;
      }
    }

    const BRAND_CODE = selectedItem ? selectedItem.productcode : 0;
    console.log("Brand Code:", BRAND_CODE);

    const staticValues = {
      COMPCODE,
      LOCCODE: STAFFMAPLOCODE,
      BYTEARRAY: croppedImg.length > 0 ? String(croppedImg.split(",")[1]) : "",
      businesstypecode: "O",
      imagepath: filePath,

      STS: CON_STATUS_ACTIVE,
      ENUSER: USERNAME,
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
      productcode: BRAND_CODE,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(SETTING_API_07, payload);
      console.log("Success:", responseData);
      setAlertMessage(
        `${isEdit ? "Updated Successfully!" : "Created Successfully!"}`
      );
      setAlertType("success");

      setAlertOpen(true);

      setSelectedItemDetails({
        productname: "",
        catcode: "",
        subcatcode: "",
        brandcode: "",
        packagecode: "",
        productcode: "",
        minorderlevel: "",
        productsize: "",
        packageunits: "",
        immeasuringunitcode: "",
        imagepath: "",
        catname: "",
        subcatname: "",
        brandname: "",
        packagename: "",
        immeasuringunit: "",
        descrip: "",
      })
      setTimeout(() => {
        navigate("/vCreateProducts");
      }, 2000);
    } catch (error) {
      console.error("Error:", error);
      setAlertType("error");
      setAlertMessage("An unexpected error occurred.");
      setAlertOpen(true); // Open the alert
    }
  };

  const handleCancel = () => {
    setSelectedItemDetails({
      productname: "",
      catcode: "",
      subcatcode: "",
      brandcode: "",
      packagecode: "",
      productcode: "",
      minorderlevel: "",
      productsize: "",
      packageunits: "",
      immeasuringunitcode: "",
      imagepath: "",
      catname: "",
      subcatname: "",
      brandname: "",
      packagename: "",
      immeasuringunit: "",
      descrip: "",
    });
    
    setCroppedImg(""); // Clear the cropped image
    setFilePath(""); // Clear the file path
    setAlertOpen(false); // Close any open alerts
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTING_API_02, "get", {
          COMPCODE,
          LOCCODE: STAFFMAPLOCODE,

          STS: CON_STATUS_ACTIVE,
        });

        setDatacat(result);
        console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTING_API_08, "get", {
          COMPCODE,
          LOCCODE: STAFFMAPLOCODE,

          STS: CON_STATUS_ACTIVE,
        });

        setDatasubcat(result);
        console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTING_API_01, "get", {
          COMPCODE,
          LOCCODE: STAFFMAPLOCODE,

          STS: CON_STATUS_ACTIVE,
        });

        setDatabrand(result);
        console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTING_API_06, "get", {
          COMPCODE,
          LOCCODE: STAFFMAPLOCODE,

          STS: CON_STATUS_ACTIVE,
        });

        setDatapack(result);
        console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTING_API_05, "get", {
          COMPCODE,
          LOCCODE: STAFFMAPLOCODE,

          STS: CON_STATUS_ACTIVE,
        });

        setDatamou(result);
        console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <Box sx={styles.box_breadcrumb}>
        <Tooltip title="Back to All Items" arrow sx={styles.breadcrumb_tooltip}>
          <IconButton
            aria-label="back"
            sx={styles.btn_breadcrumb_back}
            onClick={goBackToView}
          >
            <ArrowBackIcon sx={styles.btn_breadcrumb_back_icon} />
          </IconButton>
        </Tooltip>
        <Typography sx={styles.breadcrumb_divider}>|</Typography>

        <Breadcrumbs
          separator="›"
          aria-label="breadcrumb"
          sx={styles.breadcrumb}
        >
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            Home
          </Link>
          <Link
            sx={styles.breadcrumb_link}
            underline="hover"
            // href=""
          >
            Settings
          </Link>
          <Link
            sx={styles.breadcrumb_link_page}
            underline="hover"
            // href="#"
            aria-current="page"
          >
           Product
          </Link>
        </Breadcrumbs>
      </Box>
      <Box sx={styles.box_add_page_container}>
        <AppBar sx={styles.appbar}>
          <Grid container spacing={2} sx={styles.appbar_grid_container}>
            <Grid
              item
              size={{ xs: 8, sm: 10, md: 10, lg: 10, xl: 10 }}
              sx={styles.appbar_grid_container_col_1}
            >
              <Typography sx={styles.appbar_title}>{isEdit ? "Edit Product" : "Create  Product"}</Typography>
            </Grid>
          </Grid>
        </AppBar>
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={styles.add_form_page_container}
        >
          <Grid container spacing={2} sx={styles.add_form_page_grid_container}>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
            <TextField
  id="brand-name"
  label="Product Name"
  variant="outlined"
  fullWidth
  size="small"
  required
  name="productname"
  value={selectedItemDetails.productname} // Fallback to an empty string
  onChange={handleInputChange}
  error={!!error.productname}
  helperText={error.productname}
  FormHelperTextProps={{
    sx: { fontSize: "12px", color: "red" }, // Customize font size and color
  }}
/>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <Autocomplete
                options={Array.isArray(datacat) ? datacat : []} // Ensure datacat is an array
                getOptionLabel={(option) => option.catname || ""} // Use catname or fallback to an empty string
                disableClearable
                value={
                  Array.isArray(datacat)
                    ? datacat.find(
                        (item) => item.catname === selectedItemDetails.catname
                      ) || null
                    : null
                } // Match the selected value or fallback to null
                onChange={(event, newValue) => {
                  handleInputChange({
                    target: {
                      name: "catcode",
                      value: newValue ? newValue.catcode : "", // Update catcode
                    },
                  });
                  handleInputChange({
                    target: {
                      name: "catname",
                      value: newValue ? newValue.catname : "", // Update catname
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <span>
                        Category Name<span style={{ color: "red" }}> *</span>
                      </span>
                    }
                    variant="outlined"
                    error={!!error?.catname} // Show error if catcode has an issue
                    helperText={error?.catname} // Display helper text for the error
                    size="small"
                    name="catcode"
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                    }}
                  />
                )}
                ListboxProps={{
                  style: {
                    maxHeight: 150,
                    backgroundColor: theme.palette.background.paper,
                  },
                }}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <Autocomplete
                options={Array.isArray(datasubcat) ? datasubcat : []} // Ensure datasubcat is an array
                getOptionLabel={(option) => option.subcatname || ""} // Use subcatname or fallback to an empty string
                disableClearable
                value={
                  Array.isArray(datasubcat)
                    ? datasubcat.find(
                        (item) =>
                          item.subcatcode === selectedItemDetails.subcatcode
                      ) || null
                    : null
                } // Match the selected value or fallback to null
                onChange={(event, newValue) => {
                  handleInputChange({
                    target: {
                      name: "subcatcode",
                      value: newValue ? newValue.subcatcode : "", // Update subcatcode
                    },
                  });
                  handleInputChange({
                    target: {
                      name: "subcatname",
                      value: newValue ? newValue.subcatname : "", // Update subcatname
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <span>
                        Subcategory Name<span style={{ color: "red" }}> *</span>
                      </span>
                    }
                    variant="outlined"
                    error={!!error?.subcatname} // Show error if subcatname has an issue
                    helperText={error?.subcatname} // Display helper text for the error
                    size="small"
                    name="subcatcode"
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                    }}
                  />
                )}
                ListboxProps={{
                  style: {
                    maxHeight: 150,
                    backgroundColor: theme.palette.background.paper,
                  },
                }}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <Autocomplete
                options={Array.isArray(databrand) ? databrand : []} // Ensure datacat is an array
                getOptionLabel={(option) => option.brandname || ""} // Use catname or fallback to an empty string
                disableClearable
                value={
                  Array.isArray(databrand)
                    ? databrand.find(
                        (item) =>
                          item.brandcode === selectedItemDetails.brandcode
                      ) || null
                    : null
                } // Match the selected value or fallback to null
                onChange={(event, newValue) => {
                  handleInputChange({
                    target: {
                      name: "brandcode",
                      value: newValue ? newValue.brandcode : "", // Update catcode
                    },
                  });
                  handleInputChange({
                    target: {
                      name: "brandname",
                      value: newValue ? newValue.brandname : "", // Update catname
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <span>
                        Brand Name<span style={{ color: "red" }}> *</span>
                      </span>
                    }
                    variant="outlined"
                    error={!!error?.brandname} // Show error if catcode has an issue
                    helperText={error?.brandname} // Display helper text for the error
                    size="small"
                    name="catcode"
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                    }}
                  />
                )}
                ListboxProps={{
                  style: {
                    maxHeight: 150,
                    backgroundColor: theme.palette.background.paper,
                  },
                }}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <Autocomplete
                options={Array.isArray(datapack) ? datapack : []} // Ensure datacat is an array
                getOptionLabel={(option) => option.packagename || ""} // Use catname or fallback to an empty string
                disableClearable
                value={
                  Array.isArray(datapack)
                    ? datapack.find(
                        (item) =>
                          item.packagecode === selectedItemDetails.packagecode
                      ) || null
                    : null
                } // Match the selected value or fallback to null
                onChange={(event, newValue) => {
                  handleInputChange({
                    target: {
                      name: "packagecode",
                      value: newValue ? newValue.packagecode : "", // Update catcode
                    },
                  });
                  handleInputChange({
                    target: {
                      name: "packagename",
                      value: newValue ? newValue.packagename : "", // Update catname
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <span>
                        Package Name<span style={{ color: "red" }}> *</span>
                      </span>
                    }
                    variant="outlined"
                    error={!!error?.packagename} // Show error if catcode has an issue
                    helperText={error?.packagename} // Display helper text for the error
                    size="small"
                    name="catcode"
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                    }}
                  />
                )}
                ListboxProps={{
                  style: {
                    maxHeight: 150,
                    backgroundColor: theme.palette.background.paper,
                  },
                }}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <Autocomplete
                options={Array.isArray(datamou) ? datamou : []} // Ensure datacat is an array
                getOptionLabel={(option) => option.immeasuringunit || ""} // Use catname or fallback to an empty string
                disableClearable
                value={
                  Array.isArray(datamou)
                    ? datamou.find(
                        (item) =>
                          item.immeasuringunitcode ===
                          selectedItemDetails.immeasuringunitcode
                      ) || null
                    : null
                } // Match the selected value or fallback to null
                onChange={(event, newValue) => {
                  handleInputChange({
                    target: {
                      name: "immeasuringunitcode",
                      value: newValue ? newValue.immeasuringunitcode : "", // Update catcode
                    },
                  });
                  handleInputChange({
                    target: {
                      name: "immeasuringunit",
                      value: newValue ? newValue.immeasuringunit : "", // Update catname
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <span>
                        Measuring unit<span style={{ color: "red" }}> *</span>
                      </span>
                    }
                    variant="outlined"
                    error={!!error?.immeasuringunit} // Show error if catcode has an issue
                    helperText={error?.immeasuringunit} // Display helper text for the error
                    size="small"
                    name="catcode"
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                    }}
                  />
                )}
                ListboxProps={{
                  style: {
                    maxHeight: 150,
                    backgroundColor: theme.palette.background.paper,
                  },
                }}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <TextField
                id="minorderlevel"
                label="Minimum Order Level"
                variant="outlined"
                fullWidth
      
                size="small"
                name="minorderlevel"
                value={selectedItemDetails.minorderlevel}
                onChange={handlenumInputChange}
                onFocus={(e) => {
                  if (e.target.value === "0") {
                    handlenumInputChange({
                      target: {
                        name: "minorderlevel",
                        value: "",
                      },
                    });
                  }
                }}
                error={!!error.minorderlevel}
                helperText={error.minorderlevel}
                FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                }}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <TextField
                id="productsize"
                label="Product Size"
                variant="outlined"
                fullWidth
                size="small"
                name="productsize"
                value={selectedItemDetails.productsize}
              onChange={handleInputChange}
                onFocus={(e) => {
                  if (e.target.value === "0") {
                    handlenumInputChange({
                      target: {
                        name: "productsize",
                        value: "",
                      },
                    });
                  }
                }}
                error={!!error.productsize}
                helperText={error.productsize}
                FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                }}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <TextField
                id="packageunits"
                label="Package Units"
                variant="outlined"
                fullWidth
                size="small"
                name="packageunits"
                value={selectedItemDetails.packageunits}
                onChange={handlenumInputChange}
                onFocus={(e) => {
                  if (e.target.value === "0") {
                    handlenumInputChange({
                      target: {
                       name: "packageunits",
                        value: "",
                      },
                    });
                  }
                }}
                error={!!error.packageunits}
                helperText={error.packageunits}
                FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                }}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <TextField
                id="description"
                label="Description"
                variant="outlined"
                fullWidth
                size="small"
                name="descrip"
                value={selectedItemDetails.descrip}
                onChange={handleInputChangedes}
                onFocus={(e) => {
                  if (e.target.value === "0") {
                    handlenumInputChange({
                      target: {
                        name: "minorderlevel",
                        value: "",
                      },
                    });
                  }
                }}
                // error={!!error.descrip}
                // helperText={error.descrip}
                FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                }}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column", // Align items vertically
                  alignItems: "center", // Center items horizontally
                  justifyContent: "center", // Center items vertically
                  gap: 2, // Add spacing between elements
                  width: "100%", // Ensure the container takes full width
                }}
              >
                <Box
                  sx={{
                    ml: -52, // Add left margin to the cropper
                    display: "flex",
                  }}
                >
                  <ImageCropper
                    onCropComplete={handleCroppedImage}
                    FIXED_WIDTH={CON_MENUICON_WIDTH}
                    FIXED_HEIGHT={CON_MENUICON_HEIGHT}
                    MAX_FILESIZE={CON_MAX_FILESIZE_ITEMIMG}
                    setSnackbarMessage={setAlertMessage}
                    setOpenErrorSnackbar={setAlertOpen}
                    setFilePath={setFilePath}
                  />
                </Box>
                <Box
                  sx={{
                    width: 210,
                    height: 210,
                    border: "1px solid #ccc",
                    borderRadius: 1,
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#f9f9f9",
                    flexShrink: 0,
                  }}
                >
                  {croppedImg ? (
                    <img
                      src={croppedImg}
                      alt="Cropped Result"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : selectedItemDetails.imagepath ? (
                    <img
                      src={selectedItemDetails.imagepath}
                      alt="Selected Item"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <Box
                      sx={{
                        fontSize: 14,
                        color: "#888",
                        textAlign: "center",
                      }}
                    >
                 No Image Available
                    </Box>
                  )}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box sx={styles.add_form_page_button_box}>
          <Button
            variant="outlined"
            size="medium"
            sx={{ ...styles.btn_secondary, ...styles.btn_add_cancel }}
            onClick={handleCancel}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            size="medium"
            sx={{ ...styles.btn_primary, ...styles.btn_add_confirm }}
            onClick={handleConfirmClick}
          >
            {isEdit ? "Modify" : "Confirm"}
          </Button>
        </Box>

        <SystemAlert
          open={alertOpen}
          type={alertType}
          message={alertMessage}
          onClose={() => setAlertOpen(false)}
        />
      </Box>
    </>
  );
}

export default CreateProducts;
